module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan3-3-5166653021f25315fdaa2fc94de082de.webp";